// Matter/Legislation interfaces from Legistar API
export interface Matter {
  MatterId: number;
  MatterGuid: string;
  MatterFile: string;
  MatterName: string;
  MatterTitle: string;
  MatterTypeName: string;
  MatterStatusName: string;
  MatterBodyId: number;
  MatterBodyName: string;
  MatterIntroDate: string;
  MatterAgendaDate: string | null;
  MatterPassedDate: string | null;
  MatterEnactmentDate: string | null;
  MatterEnactmentNumber: string | null;
  MatterVersion: string;
  MatterText1: string | null;
  MatterText2: string | null;
  MatterText3: string | null;
  MatterText4: string | null;
  MatterText5: string | null;
  // Derived key dates (from legislative history action_ids, not string parsing)
  CouncilVoteDate?: string | null;
  EnactmentDate?: string | null;
  EnactmentLabel?: string | null;
  // Prime sponsor (joined from sponsors table)
  prime_sponsor_name?: string;
  prime_sponsor_id?: number;
  // Document search match indicator
  matched_attachment_text?: number;
}

export interface MatterStatus {
  MatterStatusId: number;
  MatterStatusGuid: string;
  MatterStatusName: string;
  MatterStatusSort: number;
  MatterStatusActiveFlag: number;
  MatterStatusDescription: string | null;
}

export interface MatterType {
  MatterTypeId: number;
  MatterTypeGuid: string;
  MatterTypeName: string;
  MatterTypeSort: number;
  MatterTypeActiveFlag: number;
}

export interface Person {
  PersonId: number;
  PersonGuid: string;
  PersonFirstName: string;
  PersonLastName: string;
  PersonFullName: string;
  PersonActiveFlag: number;
}

export interface Sponsor {
  MatterSponsorId: number;
  MatterSponsorGuid: string;
  MatterSponsorMatterId: number;
  MatterSponsorBodyId: number;
  MatterSponsorName: string;
  MatterSponsorNameId: number;
  MatterSponsorSequence: number;
}

export interface MatterHistory {
  MatterHistoryId: number;
  MatterHistoryGuid: string;
  MatterHistoryMatterId: number;
  MatterHistoryActionName: string;
  MatterHistoryActionBodyName: string;
  MatterHistoryActionBodyId: number;
  MatterHistoryActionDate: string;
  MatterHistoryActionText: string | null;
  MatterHistoryPassedFlag: number | null;
  MatterHistoryPassedFlagName: string | null;
}

export interface MatterAttachment {
  MatterAttachmentId: number;
  MatterAttachmentGuid: string;
  MatterAttachmentMatterId: number;
  MatterAttachmentName: string;
  MatterAttachmentHyperlink: string;
  MatterAttachmentFileName: string;
  MatterAttachmentBinary: string | null;
}

// Committee interface
export interface Committee {
  id: number;
  name: string;
}

// Filter state interfaces
export interface FilterState {
  search: string;
  searchBody: boolean;
  searchAttachments: boolean;
  statuses: string[];
  types: string[];
  sponsors: number[];
  bodyId: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  dateField: 'intro' | 'passed' | 'lastAction';
  session: string | null;
}

export interface SortState {
  field: 'MatterIntroDate' | 'MatterStatusName' | 'MatterTypeName' | 'MatterFile';
  direction: 'asc' | 'desc';
}

export interface ViewState {
  mode: 'table' | 'card';
}

// API response interfaces
export interface SearchResponse {
  items: Matter[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface FilterOptions {
  statuses: MatterStatus[];
  types: MatterType[];
  persons: Person[];
}

// Default filter state
export const defaultFilterState: FilterState = {
  search: '',
  searchBody: false,
  searchAttachments: false,
  statuses: [],
  types: [],
  sponsors: [],
  bodyId: null,
  dateFrom: null,
  dateTo: null,
  dateField: 'intro',
  session: null,
};

export const defaultSortState: SortState = {
  field: 'MatterIntroDate',
  direction: 'desc',
};
